import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, Pagination, PagingResponseModel} from "../shared";
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { Observable } from "rxjs";
import { MkpItemImageContainerModel } from '../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class MkpItemImageService extends BaseApiTemplateService<MkpItemImageContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/items/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/items/login-entity-ep';
    this.httpClient = http;
  }

  getImageItemFile(imageHdrGuid: string, visa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/image-file/" + imageHdrGuid;
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  addImageHdr(formData: FormData, hdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/add-images/' + hdrGuid;
    return this.httpClient.post<ApiResponseModel<MkpItemImageContainerModel>>(url, formData, this.getHttpHeader(visa));
  }

  replaceImageHdr(formData: FormData, extGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/replace-images/' + extGuid;
    return this.httpClient.put<ApiResponseModel<MkpItemImageContainerModel>>(url, formData, this.getHttpHeader(visa));
  }

  deleteImageHdr(imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/image-file/' + imageHdrGuid;
    return this.httpClient.delete<ApiResponseModel<any>>(url, this.getHttpHeader(visa));
  }

  public getImagesByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>( UrlByCriteria, this.getHttpHeader(visa));
  }

}